export default class TpPrepaymentProjectChangeItem {
  constructor() {
    this.ProjectId = '';
    this.LineItemId = '';
    this.TpClientInvoiceId = '';
  }
}
